import React, { useEffect, useRef } from "react";
import { InputTextarea, InputTextareaProps } from "primereact/inputtextarea";

interface AutoResizeTextareaProps extends InputTextareaProps {}

const AutoResizeTextarea: React.FC<AutoResizeTextareaProps> = (props) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    const textarea = textareaRef.current;

    const autoResize = () => {
      if (textarea) {
        textarea.style.height = "auto";
        textarea.style.height = `${textarea.scrollHeight}px`;
      }
    };

    autoResize();

    if (textarea) {
      textarea.addEventListener("input", autoResize);
    }

    return () => {
      if (textarea) {
        textarea.removeEventListener("input", autoResize);
      }
    };
  }, []);

  return (
    <InputTextarea
      {...props}
      ref={textareaRef}
      style={{ overflow: "hidden", resize: "none", ...props.style }}
    />
  );
};

export default AutoResizeTextarea;
